import type { OrganizationPrivacy } from 'models';
import { type ReactNode, useMemo } from 'react';
import { EarthLineIcon, MailLineIcon, RoundElement } from 'ui';

type PrivacyInformation = {
  description: string;
  icon: ReactNode;
  name: string;
};

export const useGetOrganizationPrivacyInformation = ({
  privacy,
}: {
  privacy: OrganizationPrivacy;
}): PrivacyInformation =>
  useMemo(() => {
    switch (privacy) {
      case 'public':
        return {
          description: 'Any member can join',
          icon: (
            <RoundElement color="default" size="extra-small">
              <EarthLineIcon type="dark-default" />
            </RoundElement>
          ),
          name: 'Public',
        };
      case 'secret':
        return {
          description: 'Member must be invited to be able to join',
          icon: (
            <RoundElement color="default" size="extra-small">
              <MailLineIcon type="dark-default" />
            </RoundElement>
          ),
          name: 'Secret',
        };
    }
  }, [privacy]);
